import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Dimmer, Loader } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

// "use strict";

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

//dropdown CLASES
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({styles, handleLista2, list,  argsSelDpto}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista2" onChange={handleLista2}>
                <option style={styles.input} value="">Todas...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};
//Fin dropdown CLASES

//dropdown RANGOS FACTURACION
const DetalleRangoNivel1 = props => {
  return (
    <option dato1={props.elemento._id} dato2={props.elemento.prefijo} value={props.elemento.proxFact+':'+props.elemento.factInicial+':'+props.elemento.factFinal} style={props.styles.input}>{props.elemento.prefijo} {props.elemento.factInicial} - {props.elemento.factFinal}</option>
  )
};

const ListaRango = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleRangoNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  // let selecc = true
  // if(list.length===1){
  //   selecc = false
  // }
  return(
    // <div>
    //   {selecc  &&
    //     <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3" onChange={(ev)=>handleChange(ev)}>
    //       <option value="">Seleccionar...</option>
    //       {Nivel1Detalle}
    //     </select>
    //   }
    //   {!selecc  &&
    //     <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3">
    //       {Nivel1Detalle}
    //     </select>
    //   }
    // </div>
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown RANGOS DE FACTURACION

//dropdown CICLOS FACTURACION
const DetalleCF1 = props => {
  return (
    <option dato1={props.elemento._id} dato2={props.elemento.noFactRET.toString()} value={props.elemento.cicloFact} style={props.styles.input}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCF1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CICLOS DE FACTURACION

//Progreso del proceso de facturación
const ProcesoFact = ({styles, progresoFact, finProceso}) => {
  let titProgreso = "Procesando ..."
  let titProgreso1 = "Seleccionando los clientes a facturar "
  return(
    <div>
      {progresoFact>0&&finProceso===0 &&
        <div>
          <div>
            <div className='ui segment'>
              <Dimmer active  style={{background: '#7F7FD5'}}>
                <Loader style={{color: '#302b63'}} indeterminate>Proceso de facturación en progreso ...</Loader>
              </Dimmer>
              <img src='images/progreso.png' alt="En progreso"/>
              </div>
          </div>

          <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
              {titProgreso}<br/>
          </p>
          {progresoFact===1 &&
            <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
              &nbsp;&nbsp;{titProgreso1}<br/>
            </p>
          }
        </div>
      }
    </div>
  )
};
//Fin progreso del proceso de facturación

const argsBuscarMC = {procesado: "N"}
const argsBuscarCCF = {procesado: "S", agno: "1964", mes: "15"}

// const fechaHoy = new Date()
// let agnoHoy = fechaHoy.getFullYear()
// let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
let agnoHoy = "2017"
let mesHoy = "03"

let argsBuscarMCNeg = {tipoqry: `[{$match: {tipo: 'X'}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}

//noFactRET: "false" => entre comillas porque en DetalleCF1 dato2 no acepta Boolean
class FactProcFactDX2 extends React.Component {
  state={argsDocum: {_id: "", mes: "",  fechaFact: "", factInicial: "", factFinal: "", pagueHasta: "",
        observaciones: "", prefijoFact: "", proxFact: "", rango: "Seleccionar...",
        cicloFact: "Seleccionar...", noFactRET: "false", checkNoFactMPF: true},
        argsSelDpto: this.props.argsSelDpto, opciones: "Imagen 1",
        permiteUpdate: true, confirmaAct: false, open: false, errors: [], progresoFact: 0, finProceso: 0}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    // console.log(ev.target)
    let cargoClientes = true
    if(!this.props.allClientes.allClientes){
      cargoClientes = false
    }
//     if(ev.target.name === "cicloFact"){
// console.log(ev.target.value)
//     }
    // const argsDocum = this.state.argsDocum
    if(ev.target.name === "rango"&&cargoClientes){
      let argsDocum = this.state.argsDocum
      
      let miLista = document.getElementById("miLista3");
      let _id = miLista.options[miLista.selectedIndex].attributes[0].value?miLista.options[miLista.selectedIndex].attributes[0].value:""
      argsDocum['_id'] = _id
      let prefijoFact = miLista.options[miLista.selectedIndex].attributes[1].value?miLista.options[miLista.selectedIndex].attributes[1].value:""
      if(prefijoFact.indexOf(":")!==-1){
        prefijoFact=""
      }
      argsDocum['prefijoFact'] = prefijoFact
      argsDocum[ev.target.name] = ev.target.value
      let posic1 = ev.target.value.indexOf(":")
      let proxFact = parseInt(ev.target.value.substr(0, posic1), 10) + 1
      let factInFin = ev.target.value.substr(posic1 + 1)
      posic1 = factInFin.indexOf(":")
      let factInicial = factInFin.substr(0, posic1)
      let factFinal = factInFin.substr(posic1 + 1)

      if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
        argsDocum['proxFact'] = (prefijoFact?prefijoFact+"-"+proxFact:proxFact).toString()
      }else{
        argsDocum['proxFact'] = ""
      }
      argsDocum['factInicial'] = factInicial
      argsDocum['factFinal'] = factFinal

      this.setState({argsDocum});
      this.setState({progresoFact: 0, finProceso: 0})
      // console.log(argsDocum)
    }
    if(ev.target.name === "prefijoFact"){
      let argsDocum = this.state.argsDocum
      // console.log(argsDocum.proxFact)
      let posic1 = argsDocum.proxFact.indexOf("-")
      if(posic1!==-1){
        argsDocum['proxFact'] = argsDocum.proxFact.substr(posic1 + 1)
      }else{
        // argsDocum['proxFact'] = argsDocum.proxFact
      }
      argsDocum['proxFact'] = ev.target.value?ev.target.value+"-"+argsDocum.proxFact:argsDocum.proxFact
      argsDocum[ev.target.name] = ev.target.value 
      this.setState({argsDocum});
      // console.log(argsDocum)
    }
    if(ev.target.name !== "rango"&&ev.target.name !== "prefijoFact"){
      let argsDocum = this.state.argsDocum
      if(ev.target.name === "checkNoFactMPF"){
        // let argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.checked
        // this.setState({argsDocum});
      }else{
        argsDocum[ev.target.name] = ev.target.value
        if(ev.target.name === "cicloFact"){
          let miLista = document.getElementById("miListaCF");
          // let _idCF = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:""
          let noFactRET = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:""
          argsDocum["noFactRET"] = noFactRET
          // console.log(noFactRET)
        }
          
        // this.setState({argsDocum});
        // console.log(argsDocum)
      }
      this.setState({argsDocum});
    }
    if(ev.target.name==="opciones"){
      if(ev.target.checked===true){
        this.setState({opciones: ev.target.value})
        // console.log(ev.target.value)
      }
    }
  }

  handleSubmit = async (ev, mesMsg, list, opciones)=>{
    //ACTUALIZAR BD
    async function crudBD(operacionCRUD, args, i) {
      // console.log("CRUD")
            if(args.ctrlCampo === 'CRUD'){
      // console.log(i)
      // console.log(args)
      const {data} = await operacionCRUD({
        variables: args
      });

      //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          console.log("MANY")
          // console.log(args)
          await operacionCRUD({
            variables: args
          });
        }
      }
    }
  
    //ENVIO PARA ACTUALIZAR BD
    async function updColecc(crudColecc, argsCrud, totDocCRUD) {
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      let codigo = 0
      // console.log(argsCrud)
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      // console.log("inicio")
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
      console.log("final")
      // let finProceso = 1
      // return finProceso
    }

    let codProcFact = new Date().getTime();
    codProcFact = codProcFact.toString()
    let proxFact = this.state.argsDocum.proxFact
    let factIniProc = proxFact, factFinProc
    let proxFactR

    // let fechaHoy = new Date()
    // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    // if(fechaHoy){
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy, fechaHoraHoy} = await response.data.fecha
      let fechaHoy = fechaFechaHoy.substr(0,10)
      let horaHoy = fechaHoraHoy.substr(11, 8)
      // console.log(fechaFechaHoy, fechaHoraHoy)
      // console.log(fechaHoy, horaHoy)
    // }else{
    //   console.log("No trajo la fecha hora")
    // }
    // console.log(fechaHoy, horaHoy)
    let argsUpd
    let argsUpdDet
    let errors = []
    if(!this.props.allClientes.allClientes||!this.props.allFacturacion.allFacturacion||
      !this.props.allMovTodos.allMovTodos||!this.props.allMovTodosCC.allMovTodosCC||
      !this.props.allMovTodosCC1.allMovTodosCC){
      errors.push({path: "Cargando", message: "La información se está cargando, por favor espere un momento"});
    }
    // if(!this.props.allClientes.allClientes){
    //   errors.push({path: "Generar", message: "Proceso de cargue de la información, por favor espere un momento..."});
    // }
    if(!this.state.argsDocum.fechaFact){
      errors.push({path: "Fecha Fra", message: "Debe seleccionar la fecha factura"});
    }
    if(!this.state.argsDocum.pagueHasta){
      errors.push({path: "Pague hasta", message: "Debe seleccionar la fecha de pague hasta"});
    }
    if(!this.state.argsDocum.rango||this.state.argsDocum.rango==="Seleccionar..."){
      errors.push({path: "Rango", message: "Debe seleccionar el rango de la numeración de facturación"});
    }
    if(!this.state.argsDocum.proxFact||this.state.argsDocum.prefijoFact+'-'===this.state.argsDocum.proxFact){
      errors.push({path: "Factura", message: "Debe indicarse el número de la próxima factura"});
    }else{
      if(this.props.allFactRtes.allFactRtes){
        let fraCliente = []
        let argsBuscarFactCli = `{'numeroFra': '${this.state.argsDocum.proxFact}'}`
        let tipoqry = `[{$match: ${argsBuscarFactCli}}]`
        argsBuscarFactCli = {tipoqry}
        let {data} = await this.props.allFactRtes.refetch(argsBuscarFactCli)
        fraCliente = await data.allFactRtes
        if(fraCliente.length>0){
          errors.push({path: "Factura", message: "La próxima factura " + this.state.argsDocum.proxFact + " YA existe"});
        }
      }
    }
    if(!this.state.argsDocum.cicloFact||this.state.argsDocum.cicloFact==="Seleccionar..."){
      errors.push({path: "Ciclo", message: "Debe seleccionar el ciclo de facturación"});
    }
    if(!this.state.argsDocum.observaciones){
      errors.push({path: "Observaciones", message: "Debe escribir las observaciones"});
    }

    // console.log(this.state.argsDocum)
    // console.log(mesMsg)
    this.setState({errors})
    if(errors.length===0){
      this.setState({progresoFact: 1})
//Guardar registro del proceso de facturación enviado
console.time(1)
      let minEspera = 0
// console.log("11")
      let argsAdd = {}
      argsAdd['codProcFact'] = codProcFact      
      argsAdd['mes'] = mesMsg
      argsAdd['fechaFact'] = this.state.argsDocum.fechaFact
      argsAdd['factInicial'] = this.state.argsDocum.factInicial
      argsAdd['factFinal'] = this.state.argsDocum.factFinal
      argsAdd['pagueHasta'] = this.state.argsDocum.pagueHasta
      argsAdd['idRangoFact'] = this.state.argsDocum._id
      if(this.state.argsSelDpto.descrDpto&&this.state.argsSelDpto.descrDpto!=="Todos..."){
        argsAdd['descrDpto'] = this.state.argsSelDpto.descrDpto}else{
          argsAdd['descrDpto'] = "Todos los Departamentos"
      }
      if(this.state.argsSelDpto.nombreCiudad&&this.state.argsSelDpto.nombreCiudad!=="Todas..."){
        argsAdd['nombreCiudad'] = this.state.argsSelDpto.nombreCiudad}else{
          argsAdd['nombreCiudad'] = "Todas las Ciudades"
      }
      if(this.state.argsSelDpto.descrClaseServ&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
        argsAdd['descrClaseServ'] = this.state.argsSelDpto.descrClaseServ}else{
          argsAdd['descrClaseServ'] = "Todas las Clases"
      }
      argsAdd['cicloFact'] = this.state.argsDocum.cicloFact
      argsAdd['observaciones'] = this.state.argsDocum.observaciones
      argsAdd['imagenInf'] = this.state.opciones
      argsAdd['fechaCreate'] = fechaHoy
      // console.log(argsAdd)
      const response = await this.props.createProcFact({
        variables: argsAdd
      });
      // console.log("22")
      const {errors, success} = response.data.createProcFact;
      if (!success){
        this.setState({errorAdd: errors})
      }
// console.log("createProcFact")
      let argsBuscarCL={}

//PARA PRUEBAS
      // let clientesFra = []
      // argsBuscarCL.numDocum = 2027
      // let campos = {_id: 1, contrato: 1, dirmayor: 1, direccion: 1, cicloFact: 1, saldoPendiente: 1, totPagoAdelSinFrar: 1,
      //   estadoCliente: 1, nombreCliente: 1, apellidoCliente: 1, fechaPrimeraActivacion: 1, tarifa: 1, oferta: 1}

      // if(this.props.allClientes.allClientes){
      //   let {data} = await this.props.allClientes.refetch(argsBuscarCL, campos)
      //   clientesFra = await data.allClientes
      // }
      // // let clientesParaPruebas = clientesFra.filter(elemento => 
      // //   elemento.contrato==="19929"||elemento.contrato==="19285"||elemento.contrato==="20730"||elemento.contrato==="21356"||elemento.contrato==="21356")

      //   let clientesParaPruebas = clientesFra.filter(elemento => 
      //     elemento.contrato==="34527"||elemento.contrato==="34527")

      //   clientesFra = []
      //   if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
      //     clientesFra = clientesParaPruebas
      //   }else{
      //     if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
      //       clientesFra = clientesParaPruebas.filter(elemento => 
      //         elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto)
      //     }else{
      //       clientesFra = clientesParaPruebas.filter(elemento => 
      //         elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
      //         elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
      //     }
      //   }
//FIN PARA PRUEBAS

//PROCESO DE FACTURACION
//Seleccionar clientes del dpto y ciudad seleccionados

// console.log(this.props.allFacturacion.allFacturacion)

//PARA PROCESO
      let clientesFra = []
      argsBuscarCL.numDocum = 2027
      argsBuscarCL.tipoProc = "Clientes para facturacion"
      argsBuscarCL.cicloFact = this.state.argsDocum.cicloFact
      let campos = {_id: 1, contrato: 1, dirmayor: 1, direccion: 1, cicloFact: 1, saldoPendiente: 1, totPagoAdelSinFrar: 1,
        estadoCliente: 1, nombreCliente: 1, apellidoCliente: 1, numeroDoc: 1, eMail: 1, fechaPrimeraActivacion: 1,
        tarifa: 1, oferta: 1}

      if(this.props.allClientes.allClientes){
        // console.log(argsBuscarCL)
        let {data} = await this.props.allClientes.refetch(argsBuscarCL, campos)
console.log(data.allClientes)
        // let {data} = await this.props.allClientes.refetch(argsBuscarCL)
        clientesFra = await data.allClientes
      }
      // console.log("clientesFra")   
// console.log(clientesFra)
// console.log(this.props.allFacturacion.allFacturacion)
// console.log(this.props.allClientes.allClientes)
      // let clientesFra = []
      if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
        // // clientesFra = this.props.allClientes.allClientes
        // clientesFra = clientesFra.filter(elemento => 
        //   elemento.cicloFact===this.state.argsDocum.cicloFact)
      }else{
        if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          // clientesFra = clientesFra.filter(elemento => 
          //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
          //   elemento.cicloFact===this.state.argsDocum.cicloFact)
          clientesFra = clientesFra.filter(elemento => 
            elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto)
        }else{
          // clientesFra = clientesFra.filter(elemento => 
          //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
          //   elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
          //   elemento.cicloFact===this.state.argsDocum.cicloFact)
          clientesFra = clientesFra.filter(elemento => 
            elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
            elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
        }
      }
//FIN PARA PROCESO

//OJOOOOO REVISAR QUE LOS CLIENTES NO TENGAN TARIFAS QUE SI TENGAN IMPTOS PERO ESTEN NULL
// console.log(this.props.allFacturacion.allFacturacion)
// console.log(this.props.allClientes.allClientes)
console.log(clientesFra)
clientesFra = clientesFra.filter(elemento => 
  elemento.estadoCliente==="RETIRADO"&&
  elemento.saldoPendiente>=10000)
console.log(clientesFra)

await this.props.allClientes.refetch({numDocum: 1})
// console.log(this.props.allClientes.allClientes)

//ORDENAR POR BARRIO + DIRECCION
let clientesFra1 = clientesFra.map(cliente => ({...cliente}))
clientesFra.forEach(async (elemento, _id) => {
  let linea1DNN = ""
  if(elemento.direccion.descrTipoVia1){
    linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
    linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
    linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
    linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
    linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
    linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
    linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
    linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
    linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
  }
  const indexLis = clientesFra1.findIndex(cliente => cliente._id === elemento._id);
  clientesFra1[indexLis].direccionFra = linea1DNN
  clientesFra1[indexLis].nombreBarrio = elemento.nombreBarrio
})
clientesFra = clientesFra1.map(cliente => ({...cliente}))

let origen = "MES " + mesMsg

let listMovCli = []

clientesFra = _.orderBy(clientesFra, ['nombreBarrio', 'direccionFra'], ['asc', 'asc'])
//FIN ORDENAR POR BARRIO + DIRECCION
// console.log("ordenado clientesFra")
      minEspera = parseInt((clientesFra.length * 30), 10)
      // console.log(minEspera)
      let tieneRegMovCli = false, tieneRegMovCliCC = false
      let creaFraMany = [], movCliMany = [], actmovCliMany = [], actCliMany = [], actCliPHMany = [],
        actPASFCliMany = [], actCliMCMany = [], creaHC = [], actMNFMany = []

      clientesFra.forEach(async (elemento, _id) => {

        let saldoCl = 0
        let saldoClIni = 0
        let saldoAnterior = 0
        let totPagoAdelSinFrar = 0
        // if(elemento.contrato==="16074"){
        //   console.log(elemento.contrato, saldoAnterior)
        // }
  
        let listServCargoFra = [];

        let valorAntesImptos = 0, valorFacturado = 0
        let valorAntesImptosCC = 0, valorFacturadoCC = 0

        let movCli=[], movCliI=[], movFras=[], creaFra=[], actmovCli=[], actCliMC=[], actMNF = []

// console.log(elemento)

//FACTURAR EL MES PARA CLIENTES DESCONECTADOS

//CREAR REGISTROS EN MOVCLIENTES Y DETALLEFACT
const numDiasMes = getNumDiasMes(mesMsg.substr(5, 2), mesMsg.substr(0, 4))

        if(elemento.estadoCliente==="RETIRADO"&&elemento.tarifa&&elemento.tarifa.servicios){
//tener en cuenta vencimiento de tarifa y oferta
//Crear registros en movclientes CON TARIFA ACTUAL
//Si la tarifa se vence en el mes, facturar con la tarifa actual y actualizar la tarifa al cliente para que
//facture el proximo mes con la nueva tarifa
// console.log("11")
// if(elemento.contrato==="99"){
  // console.log(elemento)
// }

          let numDiasAFactConOf = 0, porcDctoOferta = 0, numDiasAFactSinOfServ = 0

          let periodoFrado = mesMsg + '-01 a '
          periodoFrado += mesMsg + '-' + (numDiasMes<10?'0'+numDiasMes:(numDiasMes))
          
//Guardar en listServCargoFra los servicios a facturar
          elemento.tarifa.servicios.forEach((elemento1, i) => {
            let factServ = true

            //verificar si es de la clase seleccionada y si esta A (Activo)
            if((!this.state.argsSelDpto.descrClaseServ||this.state.argsSelDpto.descrClaseServ==="Todas..."||
            elemento1.subclaseserv.claseserv.descrClaseServ===this.state.argsSelDpto.descrClaseServ)){
              factServ = true
            }else{
              factServ = false
            }
            // console.log(elemento.contrato, factServ, this.state.argsSelDpto.descrClaseServ, elemento1.subclaseserv.claseserv.descrClaseServ)

            if(factServ){
              // console.log("55")
//FACTURAR EL SERVICIO

              let valorServ = elemento.saldoPendiente
              let valorAntesI = elemento.saldoPendiente
          //     if(elemento.contrato==="7523"||elemento.contrato==="6138"||elemento.contrato==="6377"||
          //     elemento.contrato==="15525"){
            // console.log(elemento.contrato, valorServ)
          // }
            
              if(valorServ>=10000){
                listServCargoFra.push({codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido,
                  descripcionServicio: elemento1.descripcionServicio, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                  velEfecDownstream: elemento1.velEfecDownstream, velEfecUpstream: elemento1.velEfecUpstream,
                  codigoTipoTec: elemento1.codigoTipoTec, descrTipoTec: elemento1.descrTipoTec,
                  numeroServicios: elemento1.numeroServicios, valorServicios: valorServ,
                  imptos: elemento1.imptos, agnoFra: mesMsg.substr(0, 4), mesFra: mesMsg.substr(5, 2), fechaCargo: this.state.argsDocum.fechaFact,
                  periodoFrado: periodoFrado, valorAntesImptos: valorAntesI,
                  numDiasAFactSinOf: numDiasAFactSinOfServ, numDiasAFactConOf: numDiasAFactConOf,
                  porcDctoOferta: porcDctoOferta,
                  _id: i
                });
                // console.log(listServCargoFra)
                // console.log("22")
              }
            }
          })
        }

// console.log(listServCargoFra)
// if(elemento.contrato==="99"){
//   console.log(listServCargoFra)
// }

//crea registros en movclientes
          movCli = []
          movCliI = []
// console.log(valorFacturado)
          let valorFact = valorFacturado - valorFacturadoCC
          let valorAntesI = valorAntesImptos - valorAntesImptosCC
          let tieneValNeg = false
          let numValPos = 0
          let numValNeg = 0
          let valAFact = 0
          listServCargoFra.forEach((elemento1, i) => {
            if(elemento1.valorServicios<0){
              tieneValNeg = true
              numValNeg += 1
            }else{
              numValPos += 1
            }
            valAFact += parseInt(elemento1.valorServicios, 10)
            // if(numDiasMes===elemento1.numDiasAFactSinOf){
              valorFact += elemento1.valorServicios
              valorAntesI += elemento1.valorAntesImptos
            // }else{
            //   let valorFactDia = elemento1.valorServicios / numDiasMes
            //   // console.log(valorFactDia)
            //   let valorAntesIDia = elemento1.valorAntesImptos / numDiasMes
            //   valorFact += (valorFactDia * elemento1.numDiasAFactSinOf) + (valorFactDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
            //   // console.log(valorFact)
            //   valorAntesI += (valorAntesIDia * elemento1.numDiasAFactSinOf) + (valorAntesIDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
            //   valorFact = parseInt(valorFact, 10)
            //   // console.log(valorFact)
            //   valorAntesI = parseInt(valorAntesI, 10)
            // }
            // console.log(elemento.contrato, valorFact, valorAntesI, elemento1.valorServicios)
          })
          let ctrlNumValPosONumValNegMenorQue2 = true
          if(numValPos>1&&numValNeg>1){
            ctrlNumValPosONumValNegMenorQue2 = false
            // if(elemento.contrato==="93317"){
            //   console.log(elemento.contrato, numValPos, numValNeg, ctrlNumValPosONumValNegMenorQue2)
            // }
          }
          let ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0 = true
          let saldoFin = valAFact+saldoCl
        if(numValPos>0&&numValNeg>0&&saldoCl<0&&saldoFin>0&&saldoFin+saldoCl>0){
            ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0 = false
          }
          let ctrlTienePosYNeg = false
          if(numValPos>0&&numValNeg>0){
            ctrlTienePosYNeg = true
            // if(elemento.contrato==="1201"){
            //   console.log(elemento.contrato, numValPos, numValNeg, ctrlNumValPosONumValNegMenorQue2)
            // }
          }
          
// console.log(elemento.contrato, valorFact)
//Crear factura y actualizar detalleFact
//si hay detalle a facturar => crea la factura

//se revisa si tiene saldo negativo => si tiene se calcula si queda valor por facturar
let nuevoValorFact = valorFact
let porcValorFact = 100
let totPagoAdelSinFrarIni = totPagoAdelSinFrar
let totPagoAdelSinFrarInicial = totPagoAdelSinFrar
if(totPagoAdelSinFrar>0&&nuevoValorFact>0){
  if(totPagoAdelSinFrar>nuevoValorFact){
    // console.log(elemento.contrato, totPagoAdelSinFrar, nuevoValorFact)
    totPagoAdelSinFrarIni = nuevoValorFact
    totPagoAdelSinFrar = totPagoAdelSinFrar - nuevoValorFact
    nuevoValorFact = 0
  }else{
    // console.log(elemento.contrato, totPagoAdelSinFrar, nuevoValorFact, valorAntesI)
    nuevoValorFact = nuevoValorFact - totPagoAdelSinFrar
    valorAntesI = valorAntesI - totPagoAdelSinFrar

    totPagoAdelSinFrar = 0
  }
}


let linea1DNN = ""
if(elemento.direccion.descrTipoVia1){
  linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
  linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
  linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
  linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
  linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
  linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
  linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
  linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
  linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
}

// if(this.state.argsDocum.noFactRET==="true"){
//   if(elemento.estadoCliente==="RETIRADO"&&elemento.saldoPendiente<=0){
//     console.log(elemento.contrato, nuevoValorFact)

//     nuevoValorFact = 0
//     creaFra = []
//   }
// }

// console.log(elemento.contrato, nuevoValorFact)

          if(nuevoValorFact>0){
            creaFra = []
            // console.log(elemento.contrato, saldoAnterior, nuevoValorFact)
            argsUpd = {
              "codProcFact": codProcFact,
              "idRangoFact": this.state.argsDocum._id,
              "tipoGen": "proceso",
              "numeroFra": proxFact,
              "fechaFact": this.state.argsDocum.fechaFact,
              "contrato": elemento.contrato,
              "pagueHasta": this.state.argsDocum.pagueHasta,
              "direccion": linea1DNN,
              "descrDpto": elemento.dirmayor.descrDpto,
              "codigoDptoDANE": elemento.dirmayor.codigoDptoDANE,
              "nombreCiudad": elemento.dirmayor.ciudades.nombreCiudad,
              "codigoMunicipioDANE": elemento.dirmayor.ciudades.codigoMunicipioDANE,
              "codigoPostalDANE": elemento.dirmayor.ciudades.codigoPostalDANE,
              "codigoCiudadInterno": elemento.dirmayor.ciudades.codigoCiudadInterno,
              "codBarrasRdo": elemento.dirmayor.ciudades.codBarrasRdo,
              "nombreZona": elemento.dirmayor.ciudades.zonas.nombreZona,
              "nombreBarrio": elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio,
              "nombreCliente": elemento.nombreCliente,
              "apellidoCliente": elemento.apellidoCliente,
              "numeroDoc": elemento.numeroDoc,
              "eMail": elemento.eMail,
              "fechaMov": fechaHoy,
              "valorAntesImptos": parseInt(valorAntesI * porcValorFact / 100, 10),
              "valorFacturado": nuevoValorFact,
              "valorFactura": (saldoAnterior + totPagoAdelSinFrarInicial) + nuevoValorFact,
              "agno": mesMsg.substr(0, 4),
              "mes": mesMsg.substr(5, 2),
              "numeroDocum": elemento.dirmayor.ciudades.zonas.barrios.numeroDocumR,
              "descrRecurso": elemento.dirmayor.ciudades.zonas.barrios.descrRecursoR,
              "usuarioCreate": sessionStorage.getItem('userLogin'),
              "fechaCreate": fechaHoraHoy,
            };
            creaFra.push(argsUpd)
          }

          let saldoClFra = 0
          let saldoNegPend = 0
          let updValPagar = true
          // let tieneValNeg = false
          listServCargoFra.forEach((elemento1, i) => {
            // console.log(elemento.contrato, elemento1)
            let servicioFra = this.props.allServicios.allServicios.filter(servicio => servicio.codigoServicio === elemento1.codigoServicio)
            let conceptoEnFra = ""
            let consecEnFra = -1
            if(servicioFra.length>0){
              conceptoEnFra = servicioFra[0].conceptoEnFra
              consecEnFra = servicioFra[0].consecEnFra
            }else{
              conceptoEnFra = elemento1.concepto
              consecEnFra = 9
            }

            let valorServicios = 0, valorAntesImptos = 0
            // if(numDiasMes===elemento1.numDiasAFactSinOf){
              valorServicios = elemento1.valorServicios
              valorAntesImptos = elemento1.valorAntesImptos
            // }else{
            //   let valorServiciosDia = elemento1.valorServicios / numDiasMes
            //   let valorAntesImptosDia = elemento1.valorAntesImptos / numDiasMes
            //   valorServicios = (valorServiciosDia * elemento1.numDiasAFactSinOf) + (valorServiciosDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
            //   valorAntesImptos = (valorAntesImptosDia * elemento1.numDiasAFactSinOf) + (valorAntesImptosDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
            // }
            // if(valorServicios>0&&saldoCl<0&&saldoClFra>0&&tieneValNeg){

            //   updValPagar = false
            // }
            saldoCl += parseInt(valorServicios, 10)
            let valorPag = 0
            let valorPend = 0
            if((saldoCl<valorServicios&&saldoCl>0&&saldoClFra>=0&updValPagar&updValPagar&&ctrlNumValPosONumValNegMenorQue2&&(!tieneValNeg||!ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0))||
                (saldoCl<valorServicios&&saldoCl>0&&saldoClFra>=0&&updValPagar&&tieneValNeg)){
              valorPag = parseInt(valorServicios, 10) - saldoCl
            }

            if(valorServicios-saldoCl>0&&saldoCl>0&&saldoClIni<0&&saldoClFra<0&&updValPagar&&ctrlNO_TienePosYNegYSaldoIniMenor0YSaldoFinMayor0){
              valorPag = parseInt(valorServicios-saldoCl, 10) + saldoClFra
            }
            if((saldoCl<=0&&saldoClFra<=0&&saldoCl<=saldoClFra&&valorServicios>0&&ctrlNumValPosONumValNegMenorQue2)||
                (saldoCl<=0&&saldoClFra>=0&&valorServicios>0&&!tieneValNeg)||
                (saldoCl<=0&&saldoClFra>0&&valorServicios>0&&tieneValNeg)){
                valorPag = parseInt(valorServicios, 10)
            }
            if(saldoNegPend>0&&valorPag===0){
              valorPag = saldoNegPend
            }

            saldoClFra += parseInt(valorServicios, 10)
              if(((valorServicios>0)||(saldoNegPend>=0&&valorServicios<0))&&saldoCl<0&&saldoCl<valorServicios){
              if(valorServicios>0&&saldoCl<=saldoClFra&&saldoClFra<0){
                  saldoNegPend = 0
                }else{
                  saldoNegPend = valorServicios - saldoCl
                }
            }else{
              saldoNegPend = 0
            }

            valorServicios = parseInt(valorServicios, 10)
            valorAntesImptos = parseInt(valorAntesImptos, 10)

// let valorServiciosPA = valorServicios
let valorAntesImptosPA = valorAntesImptos
// console.log(elemento.contrato, valorServiciosPA, elemento1.descripcionServicio, totPagoAdelSinFrarIni, elemento1.imptos)
// if(totPagoAdelSinFrarIni>0&&valorServiciosPA>0&&!elemento1.origenCC){
//   if(totPagoAdelSinFrarIni>valorServiciosPA){
//     // console.log(elemento.contrato)
//     totPagoAdelSinFrarIni = totPagoAdelSinFrarIni - valorServiciosPA
//     valorServiciosPA = 0
//     valorAntesImptosPA = 0
//   }else{
//     // console.log(elemento.contrato, valorServiciosPA, totPagoAdelSinFrarIni)
//     if(valorServiciosPA!==valorAntesImptosPA){
//       valorAntesImptosPA = (valorAntesImptosPA * (valorServiciosPA - totPagoAdelSinFrarIni)) / valorServiciosPA
//       valorAntesImptosPA = Math.round(valorAntesImptosPA)
//     }else{
//       valorAntesImptosPA = valorAntesImptosPA - totPagoAdelSinFrarIni
//     }
//     valorServiciosPA = valorServiciosPA - totPagoAdelSinFrarIni

//     totPagoAdelSinFrarIni = 0
//   }
// }
// console.log(nuevoValorFact)
            if(nuevoValorFact<=0){
              // console.log(nuevoValorFact)
              if(saldoCl>nuevoValorFact){
                // console.log(elemento.contrato, saldoCl, nuevoValorFact)
                // OJOOO cambiado en 20210916
                // valorPag = saldoCl
                if(saldoCl>0){
                  // if(elemento.contrato==="1201"){
                  //   console.log("2", elemento.contrato, saldoCl)
                  // }
                  valorPag = saldoCl
                }else{
                  // if(elemento.contrato==="1201"){
                  //   console.log("3", elemento.contrato)
                  // }
                  valorPag = 0
                }
              }
              if(saldoCl>0){
                // if(elemento.contrato==="1201"){
                //   console.log("4", elemento.contrato, saldoCl)
                // }
                valorPag = 0
              }
            }
            // console.log(valorPag, valorServiciosPA, valorServicios)

//             if(valorServiciosPA>0){
//               // console.log(elemento.contrato, valorServiciosPA)
//               // OJOOO cambiado en 20210421
//               // valorPend = valorServicios
//               if(valorServiciosPA >= valorPag){
// // console.log(elemento.contrato, valorServiciosPA, valorPag)
//                 valorPend = valorServiciosPA - valorPag
//               }else{
//                 // console.log(elemento.contrato, valorPag)
//                 valorPend = 0
//               }
//             }else{
//               // console.log(valorPag)
//               valorPend = 0
//             }
// console.log(valorPend, valorPag)
            movCliI = []
            // elemento1.imptos.forEach((elemento2, ii) => {
            //   if(elemento2.codigoImpto!==null){
            //     // console.log(elemento2.valorImpto, numDiasMes)
            //     let valorImptoDia = elemento2.valorImpto / numDiasMes
            //     let valorImpto = (valorImptoDia * elemento1.numDiasAFactSinOf) + (valorImptoDia * elemento1.numDiasAFactConOf * ((100 - elemento1.porcDctoOferta) / 100))
            //     valorImpto = Math.round(valorImpto)

            //     //crea imptos en movclientes
            //     argsUpd = {
            //       // "tipoAct": ii===0?"CrearImptoMC1":"CrearImptoMC2",
            //       // "origen": "MES-" + mesMsg + ' Contrato-' + elemento.contrato,
            //       // "codigoServicio": elemento1.codigoServicio,
            //       "codigoImpto": elemento2.codigoImpto,
            //       "descrImpto": elemento2.descrImpto,
            //       "porcImpto": elemento2.porcImpto,
            //       "valorImpto": valorImpto,
            //     }
            //     movCliI.push(argsUpd)

            //     if(nuevoValorFact>0&&!elemento1.origenCC&&valorServiciosPA>0){
            //       //crea det imptos fras
            //       argsUpd = {
            //         // "tipoAct": "CrearDetFra2",
            //         // "numeroFra": proxFact,
            //         "codigoServicio": elemento1.codigoServicio,
            //         "nombreResumido": elemento1.nombreResumido,
            //         "descripcionServicio": elemento1.descripcionServicio,
            //         "descrClaseServ": elemento1.descrClaseServ,
            //         "velEfecDownstream": elemento1.velEfecDownstream,
            //         "velEfecUpstream": elemento1.velEfecUpstream,
            //         "codigoTipoTec": elemento1.codigoTipoTec,
            //         "descrTipoTec": elemento1.descrTipoTec,            
            //         "concepto": elemento2.descrImpto,
            //         "periodo": elemento1.periodoFrado,
            //         "tipo": "IF",
            //         "consecEnFra": consecEnFra,
            //         "porcImpto": elemento2.porcImpto,
            //         "valor": Math.round(valorImpto * porcValorFact / 100),
            //       }
            //       movFras.push(argsUpd)
            //       // console.log(elemento.contrato, "movFras=>", argsUpd)
            //     }
            //   }
            // })

// if(valorServicios<0){
//   valorPag=0
// }
// if(valorServicios===21963){
//   valorPag=0
//   valorPend=21963
// }

            //crea movclientes
            argsUpd = {
              "contrato": elemento.contrato,
              "fechaMov": fechaHoy,
              "tipo": "C",
              "subTipo": "CF",
              "procesado": "S",
              "pagueHasta": this.state.argsDocum.pagueHasta,
              "codigoServicio": elemento1.codigoServicio,
              "nombreResumido": elemento1.nombreResumido,
              "descripcionServicio": elemento1.descripcionServicio,
              "descrClaseServ": elemento1.descrClaseServ,
              "concepto": conceptoEnFra,
              "periodo": elemento1.periodoFrado,
              "origen": "MES " + mesMsg,
              "saldoCliente": saldoCl,
              "valorTotal": valorServicios,
              "valorAntesImptos": valorAntesImptos,
              "agno": elemento1.agnoFra,
              "mes": elemento1.mesFra,
              "numeroFra": nuevoValorFact>0?proxFact:"",
              "documento": nuevoValorFact>0?proxFact:"",
              "valorPagado": valorPag,
              "valorPendiente": valorPend,
              "usuarioCreate": sessionStorage.getItem('userLogin'),
              "imptos": movCliI
            };
            // console.log(elemento.contrato, valorPag, valorPend, argsUpd)
            movCli.push(argsUpd)
            // if(elemento.contrato==="TTT53"){
              // console.log(elemento.contrato, argsUpd)
            // }
            // console.log(elemento.contrato, valorAntesImptosPA, porcValorFact, nuevoValorFact, totPagoAdelSinFrarIni)
            if(nuevoValorFact>0){
              argsUpd = {
                "codigoServicio": elemento1.codigoServicio,
                "nombreResumido": elemento1.nombreResumido,
                "descripcionServicio": elemento1.descripcionServicio,
                "descrClaseServ": elemento1.descrClaseServ,
                "velEfecDownstream": elemento1.velEfecDownstream,
                "velEfecUpstream": elemento1.velEfecUpstream,
                "codigoTipoTec": elemento1.codigoTipoTec,
                "descrTipoTec": elemento1.descrTipoTec,  
                "concepto": conceptoEnFra,
                "periodo": "Saldo pendiente",
                "tipo": "SF",
                "consecEnFra": consecEnFra,
                "valor": parseInt(valorAntesImptosPA * porcValorFact / 100, 10),
              }
              movFras.push(argsUpd)
              // console.log(elemento.contrato, "movFras=>", argsUpd)
            }
          })





        // }



//FIN FACTURAR EL MES PARA CLIENTES ACTIVOS

//GRABAR PROCESO DE FACTURACION PARA EL CLIENTE
///////////////////////////////////////
        // if(creaFra.length>0){
//Para agregar los servicios de CF y despues los impuestos de cada CF en la OS
          // const creaFra_0 = [], creaFra_1 = [], movFras_0 = [], movFras_1 = []
          // // creaFra.forEach((elemento, i) => i===0?creaFra_0.push(elemento):creaFra_1.push(elemento))
          // movFras.forEach((elemento, i) => i===0?movFras_0.push(elemento):movFras_1.push(elemento))

          // const movCli_0 = [], movCli_1 = [], movCliI_0 = [], movCliI_1 = []
          // movCli.forEach((elemento, i) => i===0?movCli_0.push(elemento):movCli_1.push(elemento))
          // movCliI.forEach((elemento, i) => i===0?movCliI_0.push(elemento):movCliI_1.push(elemento))

//actualizar paguehasta en clientes
let fechaPH = null
if(elemento.pagueHasta){
  // console.log(elemento.pagueHasta)
  // console.log(this.state.argsDocum.pagueHasta)
  fechaPH = elemento.pagueHasta.substr(0, 10)

  let fechaInicio = new Date(elemento.pagueHasta.substr(0, 10)).getTime();
  let fechaFin = new Date(this.state.argsDocum.pagueHasta.substr(0, 10)).getTime();
  if(fechaInicio > fechaFin){
    fechaPH = this.state.argsDocum.pagueHasta
  }
}else{
  fechaPH = this.state.argsDocum.pagueHasta
}
// if(elemento.contrato==="W6205"||elemento.contrato==="42986"elemento.contrato==="42986"elemento.contrato==="42986"elemento.contrato==="42986"){
//   console.log(elemento.contrato, fechaPH, saldoCl)
// }
let actCliPH = []
argsUpd = {
  "tipoAct": "EditarCliPagueHasta",
  "contrato": elemento.contrato,
  "pagueHasta": fechaPH,
}
actCliPH.push(argsUpd)

//actualizar saldoCliente
let actCli = []
argsUpd = {
  "tipoAct": "EditarCliOdeS",
  "_id": elemento._id,
  "estadoCliente": elemento.estadoCliente,
  "cargoMensual": elemento.cargoMensual,
  "saldoPendiente": saldoCl,
}
actCli.push(argsUpd)

let actPASFCli = []
argsUpd = {
  "tipoAct": "EditarCliPagoAdelSF",
  "contrato": elemento.contrato,
  "totPagoAdelSinFrar": totPagoAdelSinFrar,
}
actPASFCli.push(argsUpd)

  if(this.state.argsDocum.noFactRET==="true"){
    if((elemento.estadoCliente==="RETIRADO"&&saldoCl<=0&&creaFra.length===1)){  
    // console.log(saldoCl)
    creaFra = []
    actPASFCli = []
    actCli = []
    actCliPH = []
    movCli = []
    actMNF = []
  }
}
// if(elemento.contrato==="44676"||elemento.contrato==="223017"||elemento.contrato==="47118"||elemento.contrato==="39838"){
//   console.log(elemento.contrato)
// }
let creaFra1 = {}
if(creaFra.length===1){

// console.log(elemento.contrato, saldoCl, totPagoAdelSinFrarInicial)
  creaFra1 = (creaFra[0])
  // creaFra1.saldoPendiente = saldoCl - totPagoAdelSinFrarInicial
  creaFra1.saldoPendiente = saldoCl
  if(movFras.length){
    creaFra1.detalleFact = movFras
  }
  creaFraMany.push(creaFra1)
}else{
  if(creaFra.length>1){
    creaFra1 = (creaFra[0])
    alert("el contrato " +  elemento.contrato + " tiene " + creaFra.length + " facturas")
  }
}

//Si saldo cliente <= 0 => se hace pend x pagar 0
if(saldoCl<=0){
  // console.log(saldoCl)
  movCli.forEach((elementoFra, ii) => {
    if(movCli[ii].valorTotal>0 && movCli[ii].valorPagado!==movCli[ii].valorTotal){
      // console.log(elemento.contrato, movCli[ii].valorTotal)
    // if(movCli[ii].valorPagado!==movCli[ii].valorTotal){
      movCli[ii].valorPagado = movCli[ii].valorTotal
    }
  })      
}

// creaFraMany.push(creaFra1)
movCli.forEach((elementoFra, ii) => {
  movCliMany.push(elementoFra)
})
actmovCli.forEach((elementoFra, ii) => {
  actmovCliMany.push(elementoFra)
})
actCliMC.forEach((elementoFra, ii) => {
  actCliMCMany.push(elementoFra)
})
actCli.forEach((elementoFra, ii) => {
  actCliMany.push(elementoFra)
})
actCliPH.forEach((elementoFra, ii) => {
  actCliPHMany.push(elementoFra)
})
actPASFCli.forEach((elementoFra, ii) => {
  actPASFCliMany.push(elementoFra)
})
actMNF.forEach((elementoFra, ii) => {
  actMNFMany.push(elementoFra)
})

if(creaFra.length>0){
//CREA REGISTRO EN HISTCLIENTES
  let argsAddHC = {
    "fechaHistCliente": fechaHoy + ' ' + horaHoy,
    "contrato": elemento.contrato,
    "movimiento": "Facturacion",
    "descripcion": "Proceso de Facturacion",
    "detalle": "Saldo pendiente",
    "relacion": proxFact,
    "valor": creaFra[0].valorFacturado,
    "usuarioCreate": sessionStorage.getItem('userLogin'),
  }
  creaHC.push(argsAddHC)

  
  factFinProc = proxFact
// console.log(proxFact)
//Incrementar num fra
  let posic1 = proxFact.indexOf("-")
  if(posic1===-1){
    proxFactR = parseInt(proxFact, 10)
    proxFact = (parseInt(proxFact, 10) + 1).toString()
  }else{
    proxFactR = parseInt(proxFact.substr(posic1 + 1), 10)
    proxFact = proxFact.substr(0, posic1) + '-' + (parseInt(proxFact.substr(posic1 + 1), 10) + 1).toString()
  }
}
// console.log(proxFact)
// console.log(proxFactR)
      //  }
////////////////////////////////////////
//FIN GRABAR PROCESO DE FACTURACION PARA EL CLIENTE
      })
    // }

//Crear el registro en histclientes
let creaHCMany = [], creaHCMany1 = []
creaHC.forEach((elementoHC, ii) => {
  creaHCMany.push(elementoHC)
})
creaHCMany1.push({histcliente: creaHCMany})

let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
for(let iii=0; iii<totDocCRUD; iii++){
  argsCrud.push({ctrlCampo: 'NO_CRUD'})
}
for(let iii=0; iii<totDocCRUD; iii++){
  crudColecc.push(this.props.createHistClienteMany)
}

argsCrud[numDocCRUD] = creaHCMany1[0]
argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
crudColecc[numDocCRUD] = this.props.createHistClienteMany

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
await updColecc(crudColecc, argsCrud, totDocCRUD)
      
   //VA
  // console.log(movCliMany)
  // console.log(actmovCliMany)
  // console.log(actCliMany)

  let creaFraMany1 = []
  creaFraMany1.push({facturacion: creaFraMany})

  let movCliMany1 = []
  // movCliMany1.push({movcliente: movCliMany})

  let actCliMany1 = []
  actCliMany1.push({cliente: actCliMany})

  let actCliPHMany1 = []
  actCliPHMany1.push({cliente: actCliPHMany})

  let actPASFCliMany1 = []
  actPASFCliMany1.push({cliente: actPASFCliMany})

  let actmovCliMany1 = []
  // actmovCliMany1.push({movcliente: actmovCliMany})

  let actCliMCMany1 = []
  actCliMCMany1.push({movcliente: actCliMCMany})

  let actMNFMany1 = []
  actMNFMany1.push({mesnofra: actMNFMany})

// console.log(movCliMany1)
// console.log(actCliMany1)
// console.log(actmovCliMany1)
// console.log(actMNFMany1)
//Crear el cargo especial y los movcliente
  numDocCRUD = 0
  totDocCRUD = 5
  // if(tieneRegMovCli&&tieneRegMovCliCC){
  //   // console.log("tiene movcli y movclicc")
  //   totDocCRUD = 8
  // }else{
  //   if(!tieneRegMovCli&&tieneRegMovCliCC){
  //     console.log("solo tiene movclicc")
  //     totDocCRUD = 6
  //   }
  // }
  argsCrud = []
  crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    // if(!tieneRegMovCli&&tieneRegMovCliCC){
    //   crudColecc.push(this.props.editMovCliCCMany)
    // }else{
      crudColecc.push(this.props.createFacturacionMany)
    // }
  }

  argsCrud[numDocCRUD] = creaFraMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.createFacturacionMany
 
  // numDocCRUD += 1

  // argsCrud[numDocCRUD] = movCliMany1[0]
  // argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  // argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  // crudColecc[numDocCRUD] = this.props.createMovClientesMany

  numDocCRUD += 1

  argsCrud[numDocCRUD] = actCliMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editClienteMany

  numDocCRUD += 1

  argsCrud[numDocCRUD] = actMNFMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editMesNoFraMany

  numDocCRUD += 1

  argsCrud[numDocCRUD] = actCliPHMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editClienteMany

  numDocCRUD += 1

  argsCrud[numDocCRUD] = actPASFCliMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editClienteMany

  numDocCRUD += 1

  // if(tieneRegMovCliCC){
  //   // console.log("editMovCliCCMany")
  //   argsCrud[numDocCRUD] = actmovCliMany1[0]
  //   argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  //   argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  //   crudColecc[numDocCRUD] = this.props.editMovCliCCMany

  //   numDocCRUD += 1
  // }

  // if(tieneRegMovCli){
  //   // console.log("editMovClientesMany")

  //   argsCrud[numDocCRUD] = actCliMCMany1[0]
  //   argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  //   argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  //   crudColecc[numDocCRUD] = this.props.editMovClientesPHMany

  //   numDocCRUD += 1

  //   argsCrud[numDocCRUD] = actmovCliMany1[0]
  //   argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  //   argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  //   crudColecc[numDocCRUD] = this.props.editMovClientesMany
  // }
  // console.log(crudColecc)
  // console.log(argsCrud)
  // console.log(totDocCRUD)
  if(creaFraMany.length>0){
// console.log(creaFraMany)
    await updColecc(crudColecc, argsCrud, totDocCRUD)
  }

      // console.log(proxFact)
      // console.log(proxFactR)
      if(proxFactR===undefined){
        factIniProc = ""
        factFinProc = ""
        proxFactR = proxFact
      }
        //Actualizar próxima factura y actualizar factura inicial y final del proceso => si hay facturas generadas
        let actColecc = []
        argsUpd = {
          "_id": this.state.argsDocum._id,
          tipoAct: "EditarProxFact",
          "proxFact": proxFactR,
        }
        actColecc.push(argsUpd)
// console.log(argsUpd)

        argsUpd = {
          "codProcFact": codProcFact,
          "factInicial": factIniProc,
          "factFinal": factFinProc,
        }
        actColecc.push(argsUpd)

        numDocCRUD = 0
        totDocCRUD = 2
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editProcFact)
        }

        argsCrud[numDocCRUD] = actColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        crudColecc[numDocCRUD] = this.props.editRangoFact

        numDocCRUD += 1

        argsCrud[numDocCRUD] = actColecc[1]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
// console.log(argsCrud)
        // let finProceso = 0
        // finProceso = await updColecc(crudColecc, argsCrud, totDocCRUD)
        // console.log(factIniProc, factFinProc)
        // if(factIniProc!==factFinProc){

        await updColecc(crudColecc, argsCrud, totDocCRUD)

        // }


      console.log("listooooo")
      // console.log(finProceso)

      clientesFra = []
      argsBuscarCL={}
      argsBuscarCL.numDocum = 1
      if(this.props.allClientes.allClientes){
        let {data} = await this.props.allClientes.refetch(argsBuscarCL)
        clientesFra = await data.allClientes
      }
// console.log(clientesFra)

      const argsDocum = this.state.argsDocum
      argsDocum['observaciones'] = ""
      this.setState({argsDocum});
      var observaciones = document.getElementById("observaciones");
      observaciones.value = ""

      // if(finProceso===1){
      //   this.setState({finProceso})
      // }
      // console.log(minEspera)
      setTimeout(async (minEspera) => {
        console.log("Ultimo proceso")


        console.timeEnd(1)

        let argsDocum = this.state.argsDocum      
        argsDocum['prefijoFact'] = ""
        argsDocum['proxFact'] = ""
        argsDocum['factInicial'] = ""
        argsDocum['factFinal'] = ""
        argsDocum['rango'] = "Seleccionar..."
        argsDocum['cicloFact'] = "Seleccionar..."
        this.setState({argsDocum});

        this.setState({finProceso: 1})

        alert("!! Proceso finalizado !!")

        this.props.allRangoFact.refetch()
        let rango = document.getElementById("miLista3");
        rango.options.selectedIndex = 0
        let cicloFact = document.getElementById("miListaCF");
        cicloFact.options.selectedIndex = 0

        this.props.allMovTodos.refetch()
        this.props.allMovTodosCC.refetch()
      }, minEspera);

      // this.setState({finProceso: 1})
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }
  
  componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoMunicipioDANE'] = ""
        argsSelDpto['codigoPostalDANE'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
  
    if(this.props.argsSelDpto!==prevProps.argsSelDpto){
      this.setState({argsSelDpto: this.props.argsSelDpto})
    }
  }

  render(){
    const {argsDocum, opciones, permiteUpdate, confirmaAct, open, errors, progresoFact, finProceso} = this.state;
    // console.log(this.props.allMovTodos.allMovTodos)
    // console.log(this.props.allClientes.allClientes)
    // console.log(this.props.allFacturacion.allFacturacion)
    // console.log(this.props.allCargoEsp.allCargoEsp)
    // console.log(this.props.allMovTodosCC.allMovTodosCC)
// console.log(this.props.argsSelDpto, this.state.argsSelDpto, this.props.codigoCiudadUA)
    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selciudad(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    
    const fechaHoy = new Date()
    let agnoHoy = fechaHoy.getFullYear()
    let agnoAnt = fechaHoy.getFullYear()
    let agnoSig = fechaHoy.getFullYear()

    let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    let mesAnt = ((fechaHoy.getMonth())<10?'0'+(fechaHoy.getMonth()):(fechaHoy.getMonth()))
    let mesSig = ((fechaHoy.getMonth()+2)<10?'0'+(fechaHoy.getMonth()+2):(fechaHoy.getMonth()+2))
    
    if(mesAnt==='00'){
      agnoAnt=fechaHoy.getFullYear()-1
      mesAnt='12'
    }

    if(mesSig.toString()==='13'){
      agnoSig=fechaHoy.getFullYear()+1
      mesSig='01'
    }

    mesHoy = agnoHoy + "-" + mesHoy
    mesAnt = agnoAnt + "-" + mesAnt
    mesSig = agnoSig + "-" + mesSig

    let mesMsg = ""
    argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
    let mensaje = "Generar facturación para el mes " + mesMsg + " a RET"
    let imgIcon = "images/archivo_32.png"

    let factRet = false
    argsDocum.noFactRET==="true"?factRet=true:factRet=false

    let list = []
    if(this.props.allRangoFact.allRangoFact){
      list = this.props.allRangoFact.allRangoFact
      list = list.filter(elemento => elemento.estadoRangoFact===true)
    }

    // console.log(argsDocum.noFactRET, factRet)
// console.log(this.props.listaCF)
    return(
      <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              Generar facturación a RET
          </button>
          <div>
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, mesMsg, list, opciones):()=>{}}>
                        <div>
                            <div className="ui two column stackable grid">
                                <div className="row container">
                                    <div className="column" style={{width: '50%'}}>
                                      <h1 style={{color: 'red'}}>Generar facturación a RET</h1>
                                      <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
                                          Se generan facturas solo a los clientes en estado<br/>
                                          RETIRADO con saldo mayor o igual a $10.000
                                      </p>
                                    </div>
                                    <div className="column" style={{width: '50%'}}>
                                      <p>
                                        <span style={{background: '#7F7FD5', padding: '0.5em', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                                          Mes a facturar: &nbsp;&nbsp;
                                          <span>
                                            <input style={{color: '#302b63', fontSize: '2em', paddingright: '2.5em'}} type='month' defaultValue={mesHoy} min={mesAnt} max={mesSig} name="mes" id="mes" onChange={this.handleChange}/>
                                          </span>
                                        </span>
                                      </p>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>

                            {
                              errors.length?
                                <Message negative header="Los siguientes errores:"
                                list={errors.map(error=>`${error.path}: ${error.message}`)} />
                              :
                                <div>
                                  {/* <hr></hr> */}
                                  <ProcesoFact styles={this.props.styles} progresoFact={progresoFact} finProceso={finProceso}/>
                                </div>
                            }

                            {factRet?
                              <div>
                                {/* <h4 style={{color: '#2C7744'}}>NO SE VA A FACTURAR clientes en estado RETIRADO que al procesar para facturar queden con saldo menor o igual a cero</h4> */}
                                <h4 style={{color: '#2C7744'}}>NO SE VA A FACTURAR clientes en estado RETIRADO que queden con saldo menor o igual a cero</h4>
                                <hr></hr>
                                <hr></hr>
                              </div>
                            :
                              <div>
                                <hr></hr>
                              </div>
                            }

                            <div className="ui four column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '25%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Fecha factura
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} type='date' name="fechaFact" id="fechaFact" value={argsDocum.fechaFact} onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Rango
                                    </p>
                                    <Form.Field>
                                      <ListaRango styles={this.props.styles} list={list} handleChange={this.handleChange} />
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '10%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Prefijo
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} autoComplete="off" name="prefijoFact" id="prefijoFact" value={argsDocum.prefijoFact} onChange={this.handleChange} placeholder='Prefijo'/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '15%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Próx fra
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} autoComplete="off" name="proxFact" id="proxFact" value={argsDocum.proxFact} onChange={this.handleChange} placeholder='Próxima factura'/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Pague Hasta
                                    </p>
                                    <Form.Field>
                                      <input style={this.props.styles.input} type='date' name="pagueHasta" id="pagueHasta" value={argsDocum.pagueHasta} onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Departamento
                                  </p>
                                  <Form.Field>
                                    <ListaDe list={this.props.list1} styles={this.props.styles}
                                        handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                                        codigoDptoUA={this.props.codigoDptoUA}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Ciudad
                                  </p>
                                  <Form.Field>
                                    <ListaCi list={listCiu} styles={this.props.styles}
                                      handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                                      codigoCiudadUA={this.props.codigoCiudadUA}/>
                                  </Form.Field>
                                </div>
                              </div>
                            </div>
                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Clase
                                  </p>
                                  <Form.Field>
                                    <Lista styles={this.props.styles} list={this.props.list2} handleLista2={this.props.handleLista2}  argsSelDpto={this.props.argsSelDpto}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Ciclo de facturación
                                  </p>
                                  <Form.Field>
                                    <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                                  </Form.Field>
                                </div>
                              </div>
                            </div>

                            {/* <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Clase
                            </p>
                            <Form.Field>
                              <Lista styles={this.props.styles} list={this.props.list2} handleLista2={this.props.handleLista2}  argsSelDpto={this.props.argsSelDpto}/>
                            </Form.Field> */}
                            <hr></hr>
                            <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Observaciones
                            </p>
                            <Form.Field>
                              <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" onChange={this.handleChange} placeholder='Observciones'/>
                            </Form.Field>
                            <hr></hr>

                            <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Imagen a imprimir en la parte inferior de la factura&nbsp;&nbsp;&nbsp;</legend>
                              <div className="ui two column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '50%'}}>
                                    <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="Imagen 1" defaultChecked="true" onChange={this.handleChange}></input>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Imagen 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                  </div>
                                  <div className="column" style={{width: '50%'}}>
                                    <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="Imagen 2" onChange={this.handleChange}></input>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Imagen 2</label>
                                  </div>
                                </div>
                              </div>

                              <div className="ui two column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '50%'}}>
                                    <img width="354" height="141" src="images/logoclienteinf.jpeg" alt="imagen1"></img>
                                  </div>
                                  <div className="column" style={{width: '50%'}}>
                                    <img width="354" height="141" src="images/logoclienteinf2.jpeg" alt="imagen2"></img>
                                  </div>
                                </div>
                              </div>
                            </fieldset>

                            <hr></hr>

                            <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                        </div>
                        {/* {
                          errors.length?
                                    <Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />
                                      :
                                      <ProcesoFact styles={this.props.styles} progresoFact={progresoFact} finProceso={finProceso}/>
                        } */}

                      </Form>
                    </div>
                </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.mutation.createProcFact, {name:'createProcFact'}),
  graphql(queries.mutation.createFacturacion, {name:'createFacturacion'}),
  graphql(queries.mutation.editFacturacionUpdDoc, {name:'editFacturacionUpdDoc'}),
  graphql(queries.mutation.editRangoFact, {name:'editRangoFact'}),
  graphql(queries.mutation.editProcFact, {name:'editProcFact'}),

  graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.query.allMovTodos, {name:'allMovTodos', options: (props) => {return {variables: argsBuscarMC}}}),
  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  graphql(queries.mutation.editMovClientesPHMany, {name:'editMovClientesPHMany'}),
  graphql(queries.query.allMovTodosCC, {name:'allMovTodosCC', options: (props) => {return {variables: argsBuscarMC}}}),
  graphql(queries.query.allMovTodosCC, {name:'allMovTodosCC1', options: (props) => {return {variables: argsBuscarCCF}}}),

  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {agno: agnoHoy, mes: mesHoy}}}}),
  graphql(queries.query.allCargoEsp, {name:'allCargoEsp', options: (props) => {return {variables: {agno: agnoHoy, mes: mesHoy}}}}),

  graphql(queries.query.allFactRtes, {name:'allFactRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {fechaFact: new Date("2018-04-07")}}]`}}}}),
  
  graphql(queries.mutation.createFacturacionMany, {name:'createFacturacionMany'}),
  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editMovClientesMany, {name:'editMovClientesMany'}),
  graphql(queries.mutation.editMovCliCCMany, {name:'editMovCliCCMany'}),

  graphql(queries.query.allMovRtes, {name:'allMovRtes', options: (props) => {return {variables: argsBuscarMCNeg}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {agno: '9999'}}}}),

  graphql(queries.query.allMesNoFra, {name:'allMesNoFra', options: (props) => {return {variables: {procesado: "N"}}}}),
  graphql(queries.mutation.editMesNoFraMany, {name:'editMesNoFraMany'}),


  graphql(queries.mutation.fecha, {name:'fecha'}),
  )(FactProcFactDX2)
